// extracted by mini-css-extract-plugin
export var alertIcon = "_uu-0";